import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { CheckCircle2, Award, Users, Clock, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function AboutPage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-202" data-mp="6gyi79biu9k">
      <Navbar data-id="element-203" data-mp="3re35o9v8xev6" />

      <main className="flex-grow pt-24" data-id="element-204" data-mp="3rdti0sxobjsn">
        {/* Hero / Intro Section */}
        <Section className="relative overflow-hidden" data-id="element-205" data-mp="3mdnr5ez8a1bm">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-206" data-mp="3mga0nk5oiqwh">
            {/* Image Column */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} className="relative max-w-md mx-auto lg:mx-0" data-id="element-207" data-mp="3dd8yfujxpjy3">
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl border-8 border-white bg-gray-200" data-id="element-208" data-mp="2euwcvlhj21d2">
                {/* Profile Picture Placeholder */}
                <img src="https://cdn.magicpatterns.com/uploads/exw4rZtFTQrttLJZveReLJ/IMG_3419.jpg" alt="Construction Professional" className="w-full h-full object-cover" data-id="element-209" data-mp="25wugxkcnhywn" />

                {/* Experience Badge */}
                <div className="absolute bottom-6 right-6 bg-white/95 backdrop-blur p-4 rounded-xl shadow-lg border border-gray-100 max-w-[200px]" data-id="element-210" data-mp="32m1vu9irl9rl">
                  <div className="flex items-center gap-3 mb-1" data-id="element-211" data-mp="2osaqzefzae27">
                    <div className="p-2 bg-[#17a2b8]/10 rounded-full text-[#17a2b8]" data-id="element-212" data-mp="2ts6w5h0ewbjc">
                      <Award className="h-6 w-6" data-id="element-213" data-mp="3hi18lxgtjy32" />
                    </div>
                    <div data-id="element-214" data-mp="3maavf4mn0i14">
                      <span className="block text-2xl font-bold text-[#2c2c2c]" data-id="element-215" data-mp="3maubefsq8wci">
                        10+
                      </span>
                      <span className="text-xs text-[#525252] font-medium uppercase tracking-wider" data-id="element-216" data-mp="3w3osrin0v2lx">
                        Years Exp.
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Decorative Background Element */}
              <div className="absolute -z-10 top-10 -left-10 w-full h-full bg-[#17a2b8]/5 rounded-2xl transform -rotate-3" data-id="element-217" data-mp="3hav1z12av01y"></div>
            </motion.div>

            {/* Content Column */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-218" data-mp="38e418bcsyx11">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#17a2b8]/10 text-[#17a2b8] text-sm font-semibold mb-6" data-id="element-219" data-mp="2phkz460f29dz">
                About The Owner
              </div>

              <h1 className="text-4xl md:text-5xl font-bold text-[#2c2c2c] mb-6" data-id="element-220" data-mp="190lv1p065m68">
                Building Trust, <br data-id="element-221" data-mp="1e089u2vnbah5" />
                <span className="text-[#17a2b8]" data-id="element-222" data-mp="1dzp3ljfcyaiy">Delivering Excellence.</span>
              </h1>

              <div className="space-y-6 text-lg text-[#525252] leading-relaxed" data-id="element-223" data-mp="1izbf9ofjfipn">
                <p data-id="element-224" data-mp="lbkvkr9bdld3">
                  I'm a seasoned construction professional with over a decade of
                  experience delivering high-quality projects with a focus on
                  client satisfaction.
                </p>
                <p data-id="element-225" data-mp="v8p8e0h9s4h8">
                  As the owner of a construction company, I'm dedicated to
                  building strong relationships, ensuring seamless
                  communication, and exceeding expectations through superior
                  workmanship. My commitment to excellence and attention to
                  detail have earned me a reputation for reliability,
                  efficiency, and craftsmanship that is respected throughout the
                  Portland area.
                </p>
                <p data-id="element-226" data-mp="259bfamdwgag8">
                  Whether managing large-scale builds or intricate renovations,
                  I prioritize integrity, quality, and a client-first approach
                  in every project.
                </p>
              </div>

              <div className="mt-10 grid sm:grid-cols-2 gap-4" data-id="element-227" data-mp="2sw9uzhu73ed3">
                {['Client-First Approach', 'Superior Workmanship', 'Seamless Communication', 'Reliable & Efficient'].map((item, i) => <div key={i} className="flex items-center gap-2 text-[#2c2c2c] font-medium" data-id="element-228" data-mp="2wy4wong1ftre" data-mpi={i}>
                    <CheckCircle2 className="h-5 w-5 text-[#17a2b8]" data-id="element-229" data-mp="17lsycoa34215" />
                    {item}
                  </div>)}
              </div>

              <div className="mt-10" data-id="element-230" data-mp="3e90anu6dmta8">
                <Button variant="primary" size="lg" rightIcon={<ArrowRight className="h-5 w-5" data-id="element-232" data-mp="3j966lmjoj1y4" />} onClick={() => window.location.href = '/#contact'} data-id="element-231" data-mp="3ea1yz0celc9w">
                  Work With Me
                </Button>
              </div>
            </motion.div>
          </div>
        </Section>

        {/* Values Section */}
        <Section background="white" data-id="element-233" data-mp="2vjk6mwvhgip2">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-234" data-mp="30h3os7vaxfma">
            <h2 className="text-3xl font-bold text-[#2c2c2c] mb-4" data-id="element-235" data-mp="30e7pog7pwkw9">
              Core Values
            </h2>
            <p className="text-[#525252]" data-id="element-236" data-mp="2qiegn6t7j9j8">
              The principles that guide every project we undertake.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-237" data-mp="kqhd19r0ppyx">
            {[{
            icon: Users,
            title: 'Relationships',
            desc: 'Building lasting partnerships through trust and transparency.'
          }, {
            icon: Award,
            title: 'Quality',
            desc: 'Never compromising on materials or craftsmanship.'
          }, {
            icon: Clock,
            title: 'Reliability',
            desc: 'Showing up on time and finishing what we start.'
          }].map((value, idx) => <motion.div key={idx} whileHover={{
            y: -5
          }} className="p-8 bg-gray-50 rounded-2xl border border-gray-100 text-center" data-id="element-238" data-mp="2ggagejy0jqpb" data-mpi={idx}>
                <div className="w-14 h-14 mx-auto bg-white rounded-xl shadow-sm flex items-center justify-center text-[#17a2b8] mb-6" data-id="element-239" data-mp="22nkv6hqb6pt9">
                  <value.icon className="h-7 w-7" data-id="element-240" data-mp="30401677j8qp1" />
                </div>
                <h3 className="text-xl font-bold text-[#2c2c2c] mb-3" data-id="element-241" data-mp="2vbgkv2hgnhgj">
                  {value.title}
                </h3>
                <p className="text-[#525252]" data-id="element-242" data-mp="32ofvi3l3sqbt">{value.desc}</p>
              </motion.div>)}
          </div>
        </Section>
      </main>

      <Footer data-id="element-243" data-mp="3cl2iaxwzprgh" />
    </div>;
}